import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import ErrorBoundary from 'src/components/ErrorBoundary'
import apolloClient from 'src/lib/apolloClient'
import { AuthProvider } from 'src/contexts/AuthContext'
import Routes from 'src/Routes'

import './index.css'

const App = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ApolloProvider client={apolloClient}>
            <Routes />
          </ApolloProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
